


































































































































import Ratio from "@/components/Ratio.vue";
import Spinner from "vue-simple-spinner";
import _ from "lodash";
import assert from "assert";
import { Election, Vue } from "@/types.ts";
import { api, version } from "@/config";

export default Vue.extend({
  components: {
    Ratio,
    Spinner,
  },
  computed: {
    backendVersion(): string | null {
      return this.$store.state.version?.split("-g")[1] || null;
    },
    ballotsExport(): string | null {
      const ballots = this.election?.ballots || [];
      const blob = new Blob(
        _.map(ballots, b => JSON.stringify(b)),
        {
          type: "text/plain",
        }
      );
      return window.URL.createObjectURL(blob);
    },
    currentBallots(): number {
      const election = this.election;
      assert(election, "election is null in currentBallots");
      return election.voters.filter(v => v.time).length;
    },
    electionData(): string {
      return `${api}/elections/${this.election.uuid}/archive`;
    },
    fingerprintsDownloadButton(): HTMLLinkElement | null {
      return this.$refs.fingerprintsDownloadButton as HTMLLinkElement | null;
    },
    maxBallots(): number {
      const election = this.election;
      assert(election, "election is null in maxBallots");
      return election.voters.length;
    },
    showResults(): boolean {
      const { election } = this;
      return !!(election.tally && election.resultsPublished);
    },
    currentExpressions(): number {
      const { election } = this;
      assert(election, "election is null in currentExpressions");
      return _.reduce(
        election.voters,
        (sum, voter) => {
          if (voter.time) return sum + voter.votes;
          else return sum;
        },
        0
      );
    },
    maxExpressions(): number {
      const election = this.election;
      assert(election, "election is null in maxExpressions");
      return _.reduce(election.voters, (sum, voter) => sum + voter.votes, 0);
    },
    tally() {
      if (!this.election?.tally) return null;
      const tally = JSON.parse(this.election.tally);
      return {
        count: tally.num_tallied,
        results: tally.result,
      };
    },
    electionFingerprint(): string | null {
      if (this.election) return electionFingerprint(this.election);
      else return null;
    },
    trusteesFingerprints(): {
      required: Array<[string | null, string]>;
      threshold: Array<[string | null, string]>;
    } {
      assert(this.election, "election is null in trusteesFingerprints");
      return trusteesFingerprints(this.election);
    },
    version(): string {
      return version.split("-g")[1];
    },
    voterListFingerprint(): string {
      assert(this.election, "election is null in voterListFingerprint");
      return fingerprint(voterList(this.election));
    },
  },
  data() {
    return {
      fingerprintsUrl: undefined as string | null | undefined,
    };
  },
  methods: {
    async fingerprintsExport(): Promise<string> {
      if (this.election.ballots === undefined) {
        this.fingerprintsUrl = null;
        await this.$store.dispatch("loadElection", {
          email: this.email,
          pub: this.pub,
          uuid: this.election.uuid,
        });
      }
      const { election } = this;
      const { ballots } = election;
      const blob = new Blob(
        _.map(ballots, b => ballotFingerprint(b, election) + "\n"),
        {
          type: "text/plain",
        }
      );
      this.fingerprintsUrl = window.URL.createObjectURL(blob);
      return this.fingerprintsUrl;
    },
    publishResults() {
      this.election.resultsPublished = true;
      this.$emit("flush");
    },
    tallyAnswers(n: number): Array<[number, string, number]> {
      assert(this.tally, "tally is null in tallyAnswers");
      const question = this.election.questions[n];
      const answers = this.tally.results[n];
      const results = _.map(question.answers, (a, i) => {
        i = i + (question.blank ? 1 : 0);
        return [i, a, answers[i]] as [number, string, number];
      });
      if (question.blank) results.push([0, "Vote blanc", answers[0]]);
      return _.sortBy(results, e => -e[2]);
    },
  },
  props: {
    election: {
      type: Object as () => Election,
      required: true,
    },
    email: {
      type: String,
      required: false,
    },
    pub: {
      type: String,
      required: false,
    },
  },
  refs: ["fingerprintsDownloadButton"],
  watch: {
    fingerprintsDownloadButton(button: HTMLLinkElement) {
      if (button) button.click();
    },
  },
});
